import React from "react";
import {useMediaQuery} from "react-responsive";
import {Flex} from "@adobe/react-spectrum";
import {PHONE_MAX_WIDTH} from "../utils/constants";

function SectionFooter() {

    const isPhone = useMediaQuery({maxWidth: PHONE_MAX_WIDTH});

    return (
        <Flex direction="column" gap="size-150" alignItems={isPhone ? "stretch" : "start"}>
            <p>
                Refresh the page if the prototype seems broken. This is experimental software, sorry for any rough edges.
            </p>
            <p className="fs-14">
                <a href="https://www.adobe.com/privacy/us-rights.html"
                   rel="noreferrer"
                   target="_blank">
                    Do not sell or share my personal information
                </a>
            </p>
        </Flex>
    );
}

export default SectionFooter;